import { Data, FieldType, Form, FormField, Modal, ModalId, option, useUIActions, useUIState } from '../../../../../features/ui'
import { TableName } from '../../../../../tables'
import { useProductsState } from '../../../hooks/productsHooks'
import { useEffect, useState } from 'react'

type Props = {
    enabledCategoryIds: string[]
    onSubmit: (categoryId: string) => void
}

export const NegativeStockCategoryFormModal = (props: Props) => {
    const { enabledCategoryIds, onSubmit } = props

    const [key, setKey] = useState(0)

    const { categories } = useProductsState()
    const { openedModal } = useUIState()
    const { closeModal } = useUIActions()

    useEffect(() => setKey(key + 1), [openedModal])

    const categoryOptions = categories
        .filter(category => !category.archived && !enabledCategoryIds.includes(category.id))
        .map(category => option(category.id, category.name))

    const fields: FormField[] = [
        {
            name: 'categoryId',
            type: FieldType.TABLE,
            table: TableName.CATEGORIES,
            label: 'Categoría',
            options: categoryOptions,
            hint: 'Aplica a todos los productos sin partida de la categoría.'
        }
    ]

    const handleSubmit = (data: Data) => {
        onSubmit(data.categoryId as string)
        closeModal(ModalId.NEGATIVE_STOCK_CATEGORY_FORM)
    }

    const handleCancel = () => closeModal(ModalId.NEGATIVE_STOCK_CATEGORY_FORM)

    return (
        <Modal
            modalId={ModalId.NEGATIVE_STOCK_CATEGORY_FORM}
            title="Habilitar Venta Sin Stock por Categoría"
            widthSize='m'
            actions={[]}
        >
            <Form
                key={key}
                formId="negative-stock-category-form"
                fields={fields}
                createLabel="Agregar"
                onSubmit={handleSubmit}
                onCancel={handleCancel}
            />
        </Modal>
    )
}
